import Marquee from "react-fast-marquee";
import MotionReveal from "../motion/MotionReveal";

const companyList = [
  {
    name: "Tập đoàn Bưu chính Viễn thông Việt Nam",
    shortName: "VNPT",
    url: "https://vnpt.com.vn/",
  },
  {
    name: "Tổng Công ty Dịch vụ Viễn thông",
    shortName: "VNPT-Vinaphone",
    url: "https://vinaphone.com.vn/",
  },
  {
    name: "Tổng Công ty Hạ tầng mạng",
    shortName: "VNPT-Net",
    url: "https://vnptnet.vn/",
  },
  {
    name: "Tổng Công ty Truyền thông",
    shortName: "VNPT-Media",
    url: "https://vnptmedia.vn/",
  },
  {
    name: "Công ty Công nghệ thông tin",
    shortName: "VNPT-IT",
    url: "https://vnptit.vn/",
  },
  {
    name: "Công ty VNPT AI",
    shortName: "VNPT-AI",
    url: "https://vnptai.io/vi",
  },
  {
    name: "Công ty Viễn thông Quốc tế",
    shortName: "VNPT-I",
    url: "http://vnpti.vn/",
  },
  {
    name: "Công ty CP Công nghệ Công nghiệp BCVT",
    shortName: "VNPT-Technology",
    url: "https://vnpt-technology.vn/vi",
  },
];

const marqueeItems = [...companyList, ...companyList];

const CompanyLinksSection = () => {
  return (
    <section className="w-full overflow-hidden bg-white py-2 md:py-3 lg:py-4">
      <div className="w-full px-0">
        <MotionReveal direction="up" delay={0.18}>
          <Marquee
            gradient={false}
            speed={24}
            pauseOnHover
            pauseOnClick
            direction="right"
          >
            {marqueeItems.map((company, index) => (
              <a
                key={`${company.url}-${index}`}
                href={company.url}
                target="_blank"
                rel="noopener noreferrer"
                className="group flex min-w-[240px] flex-col items-center gap-2 justify-center px-8 py-2 no-underline md:min-w-[270px] md:px-10"
              >
                <span className="text-xs font-normal leading-6 text-slate-400 transition-colors duration-300 group-hover:text-slate-500 md:text-sm">
                  {company.name}
                </span>
                <span className="text-[20px] font-medium leading-[1.2] tracking-[-0.02em] text-slate-400 transition-colors duration-300 group-hover:text-[#0a6fd6] md:text-[24px] lg:text-[28px]">
                  {company.shortName}
                </span>
              </a>
            ))}
          </Marquee>
        </MotionReveal>
      </div>
    </section>
  );
};

export default CompanyLinksSection;
